import React from 'react'
import { Link } from 'react-router-dom'

/**
 * AppLayoutError Component
 *
 * A simple error boundary fallback component that displays an error message
 * and provides navigation options to the home page or the user's profile.
 *
 * @module appLayout/AppLayout
 * @description A simple error boundary fallback component that displays an error message
 * and provides navigation options to the home page or the user's profile.
 * @example
 * // Usage in a parent component
 * <ErrorBoundary FallbackComponent={AppLayoutError}>
 *   <YourComponent />
 * </ErrorBoundary>
 *
 * @returns {React.ReactElement} The rendered error component.
 */
export const AppLayoutError = () => {
  return (
    <div className="trtui-row trtui-mt-5 trtui-justify-content-center">
      <div className=" trtui-mt-5 trtui-col-10">
        <div className="trtui-card trtui-mt-5">
          <div className="trtui-card-body trtui-p-4">
            <div className="trtui-mb-4">
              <div className="trtui-avatar-lg trtui-mx-auto">
                <div className="trtui-avatar-title trtui-bg-light trtui-text-danger trtui-display-5 trtui-rounded-circle">
                  <i className="ri-close-line" />
                </div>
              </div>
            </div>
            <div className="trtui-p-2 trtui-mt-4">
              <div className="trtui-text-muted trtui-text-center trtui-mb-4 trtui-mx-lg-3">
                <h4>An Error Occured!</h4>
                <p>Something went wrong and an error occured!</p>
              </div>

              <div className="trtui-mt-3 trtui-text-center">
                <Link to="/" className="trtui-btn trtui-btn-primary trtui-btn-label">
                  <i className="ri-dashboard-line trtui-label-icon trtui-align-middle trtui-fs-16 trtui-me-2" />{' '}
                  Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
